import React, { useCallback, useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { BrowserView, MobileView } from 'react-device-detect';

import Navigation from "./navigation";
import Sidebar from "./sidebar";
import Footer from "./footer";
import MobileMenu from "./sidebar/mobile";
import "./shell.css";

const SIDEBAR_WIDTH_KEY = "license.sidebar.width";
const MIN_SIDEBAR_WIDTH = 216;
const MAX_SIDEBAR_WIDTH = 320;
const DEFAULT_SIDEBAR_WIDTH = 238;

const clampSidebarWidth = (width) => Math.min(MAX_SIDEBAR_WIDTH, Math.max(MIN_SIDEBAR_WIDTH, width));

const Layout = ({ children }) => {
  const [sidebarWidth, setSidebarWidth] = useState(() => {
    const stored = Number(localStorage.getItem(SIDEBAR_WIDTH_KEY));
    return Number.isFinite(stored) && stored > 0
      ? clampSidebarWidth(stored)
      : DEFAULT_SIDEBAR_WIDTH;
  });

  useEffect(() => {
    document.body.classList.add('h-100');
    const root = document.getElementById('root');
    if (root) {
      root.classList.add('h-100');
    }
    return () => {
      document.body.classList.remove('h-100');
      if (root) {
        root.classList.remove('h-100');
      }
    };
  }, []);

  const onResizeMouseDown = useCallback((event) => {
    event.preventDefault();

    const startX = event.clientX;
    const startWidth = sidebarWidth;
    document.body.style.cursor = "col-resize";
    document.body.style.userSelect = "none";

    const onMouseMove = (moveEvent) => {
      const nextWidth = clampSidebarWidth(startWidth + moveEvent.clientX - startX);
      setSidebarWidth(nextWidth);
      localStorage.setItem(SIDEBAR_WIDTH_KEY, String(nextWidth));
    };

    const onMouseUp = () => {
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    };

    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);
  }, [sidebarWidth]);

  const onResizeKeyDown = useCallback((event) => {
    if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
    event.preventDefault();

    const nextWidth = event.key === "Home"
      ? MIN_SIDEBAR_WIDTH
      : event.key === "End"
        ? MAX_SIDEBAR_WIDTH
        : clampSidebarWidth(sidebarWidth + (event.key === "ArrowLeft" ? -10 : 10));

    setSidebarWidth(nextWidth);
    localStorage.setItem(SIDEBAR_WIDTH_KEY, String(nextWidth));
  }, [sidebarWidth]);

  return (
    <>
      <BrowserView>
        <Navigation />
        <main className="licensee-main">
          <Container fluid className="licensee-shell">
            <Row className="licensee-shell-row flex-nowrap align-items-stretch">
              <Sidebar width={sidebarWidth} />
              <div
                className="licensee-sidebar-resizer"
                aria-label="Resize navigation"
                role="separator"
                tabIndex={0}
                onMouseDown={onResizeMouseDown}
                onKeyDown={onResizeKeyDown}
                style={{ cursor: "col-resize" }}
              >
                <span aria-hidden="true" />
              </div>
              <Col
                id="contentArea"
                className="licensee-content"
              >
                {children}
              </Col>
            </Row>
          </Container>
        </main>
        <Footer />
      </BrowserView>
      <MobileView>
        <MobileMenu />
        {children}
      </MobileView>
    </>
  );
};
export default Layout;
